import { authenticate } from '@cian/auth';
import { IThunkActionCreator, IState } from '..';
import { Dispatch } from 'redux';
import {
  fetchCreateSubscription,
  ICreateSubscriptionRequest,
} from '../../repositories/monolithPython/v1/create-subscription';

export interface ISubscriptionAddressState {
  isOpen: boolean;
  isLoad: boolean;
  isSubscribe: boolean;
  globalError?: string;
}

export interface ISubscriptionAddressSetVisible {
  type: 'SubscriptionAddressSetVisible';
  payload: {
    isOpen: boolean;
  };
}

export interface ISubscriptionAddressSetLoad {
  type: 'SubscriptionAddressSetLoad';
  payload: {
    isLoad: boolean;
  };
}

export interface ISubscriptionAddressSetGlobalError {
  type: 'SubscriptionAddressSetGlobalError';
  payload: {
    globalError: string | undefined;
  };
}

export interface ISubscriptionAddressSetSubscribe {
  type: 'SubscriptionAddressSetSubscribe';
  payload: {
    isSubscribe: boolean;
  };
}

export type TSubscriptionAddressActions =
  ISubscriptionAddressSetVisible |
  ISubscriptionAddressSetLoad |
  ISubscriptionAddressSetGlobalError |
  ISubscriptionAddressSetSubscribe;

const defaultState = {
  isOpen: false,
  isLoad: false,
  isSubscribe: false,
};

export function setVisible(isOpen: boolean): ISubscriptionAddressSetVisible {
  return {
    type: 'SubscriptionAddressSetVisible',
    payload: {
      isOpen,
    },
  };
}

export function setLoad(isLoad: boolean): ISubscriptionAddressSetLoad {
  return {
    type: 'SubscriptionAddressSetLoad',
    payload: {
      isLoad,
    },
  };
}

export function setGlobalError(globalError: string | undefined): ISubscriptionAddressSetGlobalError {
  return {
    type: 'SubscriptionAddressSetGlobalError',
    payload: {
      globalError,
    },
  };
}

export function setSubscribe(isSubscribe: boolean): ISubscriptionAddressSetSubscribe {
  return {
    type: 'SubscriptionAddressSetSubscribe',
    payload: {
      isSubscribe,
    },
  };
}

export function subscribeSuccess(dispatch: Dispatch<IState>) {
  dispatch(setLoad(false));
  dispatch(setSubscribe(true));
  dispatch(setGlobalError(undefined));
}

export function fetchCreateSubscriptionRequest(parameters: ICreateSubscriptionRequest): IThunkActionCreator {
  return (dispatch, getState, { httpApi }) => {
    dispatch(setLoad(true));

    const { pageData: { subdomain } } = getState();

    return fetchCreateSubscription({ httpApi, parameters, config: { subdomain } })
      .then(({ response }) => {
        if ('errors' in response || response.status !== 'ok') {
          dispatch(setGlobalError('Ошибка при отправке. Попробуйте позже.'));
          dispatch(setLoad(false));

          setTimeout(() => dispatch(setGlobalError(undefined)), 2000);

          return undefined;
        }

        if (response.data.logonInfo) {
          const {
            logonInfo: { logOnInfo, login },
          } = response.data;

          return authenticate(logOnInfo, login, true)
            .then(() => {
              if (window.__reloadHeader__) {
                window.__reloadHeader__();
              }

              subscribeSuccess(dispatch);
            });
        }

        subscribeSuccess(dispatch);

        return undefined;
      });
  };
}

export function subscriptionAddressReducer(
  state: ISubscriptionAddressState = defaultState,
  action: TSubscriptionAddressActions,
) {
  switch (action.type) {
    case 'SubscriptionAddressSetVisible':
      return {
        ...state,
        isOpen: action.payload.isOpen,
        ...(
          !action.payload.isOpen
            ? {
              isLoad: false,
              globalError: undefined,
              isSubscribe: false,
            }
            : {}
        ),
      };

    case 'SubscriptionAddressSetLoad':
      return {
        ...state,
        isLoad: action.payload.isLoad,
      };

    case 'SubscriptionAddressSetGlobalError':
      return {
        ...state,
        globalError: action.payload.globalError,
      };

    case 'SubscriptionAddressSetSubscribe':
      return {
        ...state,
        isSubscribe: action.payload.isSubscribe,
      };

    default:
      return state;
  }
}
